// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-359ed0e1]{align-items:center;display:flex;gap:7rem;padding:1rem 4rem 4rem}.cardLeft[data-v-359ed0e1]{flex-direction:row-reverse}.featureImage[data-v-359ed0e1]{aspect-ratio:auto;width:350px}.text-purple[data-v-359ed0e1]{color:#504de6}@media (max-width:830px){.card[data-v-359ed0e1]{display:flex;flex-direction:column-reverse;gap:1.5rem;padding:1rem}.featureImage[data-v-359ed0e1]{width:80%}.featureText[data-v-359ed0e1]{text-align:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
